









import Vue from "vue";

export default Vue.extend({
  props: {
    selected: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    onClick() {
      if (!this.selected) {
        this.$emit("click");
      }
    }
  }
});
